// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9da20558","667":"e2ba6138","977":"3228f2f7"}[chunkId] + ".chunk.js";
};